var exports = {
  "kL": "container__sdNMaQ",
  "R_": "heading__9WsOja",
  "h_": "description__Cs-nAz",
  "do": "ctaLink__UaIJAG",
  "Ku": "ctaIcon__thOanV",
};

module.exports = exports;
